import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Money from "../../utils/Money";
import Time from "../../utils/Time";


export default class SpaceBalanceView extends Component {

    static propTypes = {
        selectedMonth: PropTypes.number.isRequired,
        selectedYear: PropTypes.number.isRequired,
        priorEarnings: PropTypes.number.isRequired,
        priorPayouts: PropTypes.number.isRequired,
        earningsEvents:
            PropTypes.arrayOf(
                PropTypes.shape({
                    day: PropTypes.string.isRequired,
                    advertisementId: PropTypes.number.isRequired,
                    advertisementTitle: PropTypes.string.isRequired,
                    spaceId: PropTypes.number.isRequired,
                    spaceTitle: PropTypes.string.isRequired,
                    pricePerDay: PropTypes.number.isRequired
                })).isRequired,
        payoutEvents:
            PropTypes.arrayOf(
                PropTypes.shape({
                    day: PropTypes.string.isRequired,
                    paymentIdentifier: PropTypes.string.isRequired,
                    amount: PropTypes.number.isRequired
                })).isRequired
    };

    handleYearSelectChange = (e) => {
        EventPublisher.publish(
            UIInteractionEvents.SPACE_BALANCE_SELECTED_MONTH_CHANGED,
            {
                selectedYear: parseInt(e.target.value, 10),
                selectedMonth: this.props.selectedMonth
            });
    };

    handleMonthSelectChange = (e) => {
        EventPublisher.publish(
            UIInteractionEvents.SPACE_BALANCE_SELECTED_MONTH_CHANGED,
            {
                selectedYear: this.props.selectedYear,
                selectedMonth: parseInt(e.target.value, 10)
            });
    };

    handlePreviewSpaceClick = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.SPACE_DETAILS_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handlePreviewAdvertisementClick = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_ADVERTISEMENT_PREVIEW_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    render() {

        const yearsToSelectFrom = Array.from({length: Time.getCurrentYear() - 2020 + 1}, (v,k)=> k+2020);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Balance
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center mb-2">
                                    <form className="form-inline">
                                        <select
                                                className="form-control custom-select"
                                                defaultValue={this.props.selectedYear}
                                                onChange={this.handleYearSelectChange}
                                        >
                                            {yearsToSelectFrom.map((year) => {
                                                return (
                                                    <option key={"year_"+year} value={year}>
                                                        {year}
                                                    </option>);
                                            })}
                                        </select>
                                        <select
                                                className="form-control custom-select"
                                                defaultValue={this.props.selectedMonth}
                                                onChange={this.handleMonthSelectChange}
                                        >
                                            {months.map((month, monthIndex) => {
                                                return(
                                                    <option key={"month_"+month} value={monthIndex}>
                                                        {month}
                                                    </option>);
                                            })}
                                        </select>
                                    </form>
                                </div>
                                <div className="row justify-content-center">
                                    {this._renderBalanceContents()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _renderBalanceContents() {
        let runningBalance = this.props.priorEarnings - this.props.priorPayouts;
        const events = this._mergeEarningsAndPayoutEvents();
        const currentBalance = runningBalance + events.reduce((acc, cur) => acc + cur.changeAmount, 0);

        return (
            <div className="row w-100">
                <div className="col-12">
                    <div className="row">
                        <div className="card col-md-4 mb-2 p-0 text-center border-success text-success">
                            <div className="card-header text-ce">
                                Prior Earnings
                            </div>
                            <div className="card-body">
                                <h2>
                                    {Money.formatMoney(this.props.priorEarnings)}
                                </h2>
                            </div>
                        </div>
                        <div className="card col-md-4 mb-2 p-0 text-center border-success text-success">
                            <div className="card-header">
                                Prior Payouts
                            </div>
                            <div className="card-body">
                                <h2>
                                    {Money.formatMoney(this.props.priorPayouts)}
                                </h2>
                            </div>
                        </div>
                        <div className="card col-md-4 mb-2 p-0 text-center border-success text-success">
                            <div className="card-header">
                                Current Balance
                            </div>
                            <div className="card-body">
                                <h2>
                                    {Money.formatMoney(currentBalance)}
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {this._renderTableContents(events, runningBalance)}
                    </div>
                </div>
            </div>
        );
    }

    _renderTableContents(events, runningBalance) {
        if (events.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no balance changes for the selected month.
                    <br/>
                    Try selecting a different month.
                </div>
            ); // TODO - add a link to help here "if this is an error"
        }

        return (
            <div className="table-responsive">
                <table className="table table-sm">
                    <thead className="thead-light">
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Event</th>
                        <th scope="col">Change</th>
                        <th scope="col">Balance</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        events.map((event, index) => {
                            runningBalance += event.changeAmount;
                            return (
                                <tr key={"e-"+index}>
                                    <td>
                                        {event.date}
                                    </td>
                                    <td>
                                        {event.event}
                                    </td>
                                    <td className={event.changeAmount > 0 ? "text-success" : "text-danger"}>
                                        {
                                            event.changeAmount > 0 ?
                                                "+" + Money.formatMoney(event.changeAmount) :
                                                "-" + Money.formatMoney(Math.abs(event.changeAmount))
                                        }
                                    </td>
                                    <td className={runningBalance > 0 ? "text-success" : "text-danger"}>
                                        {Money.formatMoney(runningBalance)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    _mergeEarningsAndPayoutEvents() {
        const events = [];
        for (const earningEvent of this.props.earningsEvents) {
            events.push({
                date: earningEvent.day,
                event: (
                    <span>
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={(e) =>
                                this.handlePreviewAdvertisementClick(earningEvent.advertisementId)}
                        >
                                    {earningEvent.advertisementTitle}
                        </button>
                        <span className="pl-1 pr-1"><i className="fas fa-exchange-alt"/></span>
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={(e) =>
                                this.handlePreviewSpaceClick(earningEvent.spaceId)}
                        >
                                    {earningEvent.spaceTitle}
                        </button>
                    </span>
                ),
                changeAmount: earningEvent.pricePerDay
            })
        }

        for (const payoutEvent of this.props.payoutEvents) {
            events.push({
                date: payoutEvent.day,
                event: (
                    <span>
                        Payment ID: {payoutEvent.paymentIdentifier}
                    </span>
                ),
                changeAmount: -1 * payoutEvent.amount
            });
        }

        events.sort((eventA, eventB) => eventA.date < eventB.date ? -1 : eventA.date > eventB.date ? 1 : 0);
        return events;
    }

}

